import { Light } from 'react-syntax-highlighter';
import schoolBook from 'react-syntax-highlighter/dist/cjs/styles/hljs/school-book';
import js from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript';
import css from 'react-syntax-highlighter/dist/cjs/languages/hljs/css';
import xml from 'react-syntax-highlighter/dist/cjs/languages/hljs/xml';
import bash from 'react-syntax-highlighter/dist/cjs/languages/hljs/bash';
import json from 'react-syntax-highlighter/dist/cjs/languages/hljs/json';
import python from 'react-syntax-highlighter/dist/cjs/languages/hljs/python';
import scala from 'react-syntax-highlighter/dist/cjs/languages/hljs/scala';
import java from 'react-syntax-highlighter/dist/cjs/languages/hljs/java';
import sql from 'react-syntax-highlighter/dist/cjs/languages/hljs/sql';
export const initializeSyntaxHighlights = () => {
    const registerLanguage = Light.registerLanguage;
    registerLanguage('javascript', js);
    registerLanguage('css', css);
    registerLanguage('xml', xml);
    registerLanguage('bash', bash);
    registerLanguage('json', json);
    registerLanguage('python', python);
    registerLanguage('scala', scala);
    registerLanguage('java', java);
    registerLanguage('sql', sql);
};
export const getSyntaxHighlightStyle = () => {
    return schoolBook;
};
export const SyntaxHighlighter = Light;
